import { h } from 'preact';
import { Spinner } from '@cube/blocks';
import style from './style';
import cx from 'classnames';

export default function WeatherSpinner(props) {
	return (
		<div class={cx(style.loading, props.class)} style={props.style}>
			<div>
				<Spinner class={style.spinner} />
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/components/spinner/index.js